// extracted by css-extract-rspack-plugin
export default {"crosshairContainer":"M3V822gLd1UwemGa","crosshairLine":"tvv3BtjRQQc_s2tk"};